import {Component, OnInit} from '@angular/core';
import {NotificationsModelTypeAdmin, NotificationTabsEnums} from '../../../enums/notification-enums';
import {WebsocketsHelperService} from "../../../services/helpers/websockets-helper.service";
import {Subscription} from "rxjs";

@Component({
  selector: 'gr-notifications',
  templateUrl: './notifications.component.html',
})
export class NotificationsComponent implements OnInit{
  activeTab = NotificationTabsEnums.users;
  isCreateNotificationModalOpen = false;
  customNotificationForEdit: any = null;
  usersNotificationsCount = 0;
  paymentNotificationsCount = 0;
  supportNotificationsCount = 0;
  protected readonly NotificationTabsEnums = NotificationTabsEnums;
  wsNotificationsSubscription= new Subscription();
  updateNotification = false;

  constructor(private websocketsHelperService: WebsocketsHelperService) {
  }

  ngOnInit(): void {
    this.wsNotificationsSubscription = this.websocketsHelperService.notificationReceivedSubject.subscribe((res: any) => {
      console.log('wsNotificationsSubscription u RESERVATIONS', res);
      if (res !== null && [
        NotificationsModelTypeAdmin.reservationCreatedAdmin,
        NotificationsModelTypeAdmin.reservationCreatedAdminGifts,
        NotificationsModelTypeAdmin.cancelledByUser,
        NotificationsModelTypeAdmin.cancelledByBusiness
      ].includes(res.type)) {
        this.paymentNotificationsCount++;
      }
    });
  }

}
